export default __webpack_public_path__ + "static/media/avaibleApple.8747d688.png";